<template>
  <div class="contextual-banner">
    <v-icon size="18" class="mr-2">fa-regular fa-circle-info</v-icon>
    <span class="contextual-banner__text">
      <strong>Contextual message area — TBD.</strong>
      Conditional space for user communication (e.g. credit info)
    </span>
    <v-btn size="small" class="uwill-primary-button" disabled>Action</v-btn>
  </div>
</template>

<script>
// Stub — the Figma itself marks this area "TBD" (a conditional space for
// things like credit info), not yet a defined feature. Placeholder only.
export default {
  name: "ContextualBanner"
};
</script>

<style lang="scss" scoped>
@use "../../styles/base/variables" as *;

.contextual-banner {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background-color: $uwill-lightgrey;
  font-size: 13px;
}

.contextual-banner__text {
  flex: 1;
}
</style>
